<template lang="pug">
.smsVerification
  .arrow_icon(@click="$router.go(-1)")
    img(src="@/assets/images/arrow_left.svg", alt="alt")
  h1 簡訊驗證
  p 請輸入6位驗證碼<br/>已發送至 {{ $root.phone }}
  form.control-group
    input.full-box(type="number", maxlength="6", v-model="verification_code")
  p.foot-txt
    span(v-if="time > 0") {{time}}s 後再次獲取
    span(v-else, @click="$root.goPage('/phone-num')") 重發驗證碼
</template>

<script>
import $ from 'jquery'
export default {
  name: "sms-verification",
  components: {},
  data () {
    return {
      time: 120,
      now_input: 1,
      verification_code: "",
      verCode: [
        {
          id: 1,
          value: "",
        },
        {
          id: 2,
          value: "",
        },
        {
          id: 3,
          value: "",
        },
        {
          id: 4,
          value: "",
        },
        {
          id: 5,
          value: "",
        },
        {
          id: 6,
          value: "",
        },
      ],
    };
  },
  mounted () {
    this.countTime()
  },
  watch: {
    verification_code (_code) {
      if (_code.length === 6) {
        this.authSmsCodeByPhoneNumber(_code)
      }
    }
  },
  methods: {
    // 倒計時
    countTime () {
      this.time = this.time - 1
      if (this.time > 0) {
        setTimeout(() => {
          this.countTime()
        }, 1000);
      }
    },
    // 焦點
    focusNext (e) {
      if (e.data) {
        this.now_input = this.now_input + 1
        $('#code_' + this.now_input).focus()
      } 7
      if (this.now_input === 7) {
        this.authSmsCodeByPhoneNumber()
      }
    },
    // 請求驗證簡訊驗證碼
    authSmsCodeByPhoneNumber (_authCodeNumber) {
      let vm = this
      this.$root.apis.authSmsCodeByPhoneNumber({
        cellphone: this.$root.phone,
        authcode: _authCodeNumber,
        userId: this.$root.member.user_lineId
      }, function () {
        vm.$root.getUserData()
        vm.$root.goPage('/sms-program')
      }, function () {
        vm.verification_code = ""
        alert("驗證失敗, 請重新輸入！")
      })
    }
  },
};
</script>
<style lang="sass" scoped>
.smsVerification
  background-color: #000
  position: relative
  .arrow_icon
    position: absolute
    top: 6vmin
    left: 6.1vmin
  h1
    font-size: 9vmin
    text-align: center
    color: #fff
    padding-top: 34.2vmin
  p
    font-size: 5vmin
    text-align: center
    color: #fff
    margin-top: 7vmin
  .control-group
    width: 90%
    margin: auto
    display: flex
    justify-content: center
    align-items: center
    gap: 2.5vmin
    margin-top: 6.5vmin
    .full-box
      max-width: 75vmin
      background-color: #000
      font-size: 9vmin
      color: #fff
      border: 1px solid #fff
      padding: 7.5vmin 0vmin
      border: 1px solid #22F48F
      border-radius: 1.25vmin
      text-align: center
    .ipt-box
      max-width: 13vmin
      background-color: #000
      font-size: 9vmin
      color: #fff
      border: 1px solid #fff
      padding: 7.5vmin 0vmin
      border: 1px solid #22F48F
      border-radius: 1.25vmin
      text-align: center
  .foot-txt
    font-size: 4vmin
    font-weight: 400
    color: #fff
    margin-top: 22vmin
</style>
